module.exports = __webpack_public_path__ + "media/brands/honda-9e000fa7.png";